<template v-if="userData ==true">
  <v-container fluid>
    <v-app-bar
      :collapse="collapseStatus"
      :clipped-left="true"
      v-bind:style="{'background-color': (Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color : '')}"
      app
      dark
    >
      <v-app-bar-nav-icon @click.stop="status" />
      <v-toolbar-title class="ml-0 pl-4">
        <span class="hidden-sm-and-down">{{ navbarTitle | translate }}</span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-select
          @change="changedLanguage"
          v-model="selectedLanguage.lang_code"
          :items="languagesdata"
          item-value="lang_code"
          :item-text="'lang_name' | translate"
          :label="'Language' | translate"
          outlined
          dense
          class="pt-3 d-none d-sm-flex"
          style="width:140px;"
        ></v-select>
      </v-toolbar-items>
      <v-btn class="d-none d-sm-flex" icon large>
        <v-icon large @click="contact = true">mdi-telegram</v-icon>
      </v-btn>

      <v-menu
        :close-on-content-click="false"
        offset-y
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon large v-on="on">
            <v-icon large>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item class="d-flex d-sm-none">
            <v-list-item-content>
              <v-select
                @change="changedLanguage"
                v-model="selectedLanguage.lang_code"
                :items="languagesdata"
                item-value="lang_code"
                item-text="lang_name"
                :label="'Language' | translate"
                dense
                class="d-flex d-sm-none"
              ></v-select>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="d-flex d-sm-none">
            <v-list-item-action>
              <v-icon large>mdi-telegram</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ 'Contact us' | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="d-flex d-sm-none"></v-divider>
          <v-list-item v-for="(item, index) in dropdown" :key="index" @click="action(item.action)">
            <v-list-item-action>
              <v-icon large>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="mini"
      permanent
      :mini-variant-width="widthValue"
      :mini-variant.sync="mini"
      :clipped="true"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-list-item :key="item.text" :to="item.link" link>
            <v-list-item-action>
              <v-icon large :color="(Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color: '')">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-row justify="center">
      <v-dialog v-model="contact" max-width="500">
        <v-card>
          <v-card-title class="headline">{{ 'Write to Company Representative' | translate }}</v-card-title>
          <v-card-text>
            <v-row v-if="message!== null">
              <v-col cols="12" sm="12">
                <v-alert dense outline type="success">{{ message | translate }}</v-alert>
              </v-col>
            </v-row>
            <v-form ref="contactForm" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="subject"
                    name="subject"
                    :rules="[v => !!v || 'Subject is required']"
                    :label=" 'Subject' | translate"
                    required
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                  
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    outlined
                    name="body"
                    v-model="body"
                    :rules="[v => !!v || 'Body is required']"
                    :label=" 'Body' | translate"
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                   
                  </v-textarea>
                </v-col>
              </v-row>

              <v-checkbox v-model="sendCopy" :label="'Send copy to myself' | translate"></v-checkbox>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary darken-1" text @click="contact = false">{{ 'Close' | translate}}</v-btn>

            <v-btn color="primary darken-1" text @click="contactQuery">{{ 'Submit' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import {
  LOGOUT,
  FETCH_PAGES,
  STRIPE_RESET_STATE,
  PAGES_RESET_STATE,
  CONTACT_QUERY,
  RESET_STATE,
  FETCH_NAVIGATION_BAR_STATUS,
  GLOBALS_RESET_STATE
} from "@/store/actions.type";
import {
  SET_CUR_LANGUAGE,
  SET_LOADING,
  SET_NAVBAR_WIDTH,
  SET_LOGGED_IN,
} from "@/store/mutations.type";
import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  props: {
    source: String
  },
  watch: {
    async $route(to) {
      if (to.name === "moduleplayer") {
        window.removeEventListener("resize", this.onResize);
        await store.commit(SET_NAVBAR_WIDTH, 0);
      } else {
        this.onResize();
        window.addEventListener("resize", this.onResize, { passive: true });
      }
    },
    contact(value) {
      if (value) {
        this.message = null;
        this.body = null;
        this.subject = null;
        this.sendCopy = false;
      }
    },
    languages(value){
      if(Object.keys(value).length>0){
        this.setLanguageDropdown();
      }
    },
    pagesdata(value){
      if(Object.keys(value).length>0){
        this.setDropdown()      
      }
    },
  },
  data: () => ({
    dialog: false,
    drawer: true,
    isMobile: false,
    selectedLanguage: "",
    navbarTitle: null,
    items: [],
    dropdown: [],
    contact: false,
    sendCopy: false,
    collapseStatus: false,
    subject: "",
    body: "",
    message: null,
    closeOnClick: true,
    closeOnContentClick: false,
    userData: null
  }),
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created(){
    this.setLanguageDropdown()
    this.setSidebar()
  },
  methods: {
    setLanguageDropdown(){
      this.selectedLanguage =
        this.curLanguage !== null
          ? this.curLanguage
          : this.currentUser.company.language    
      this.selLanguage(this.selectedLanguage)
      Vue.i18n.set(this.curLanguage.lang_code)  
      if(Object.keys(this.pagesdata).length>0){
        this.setDropdown()      
      }
    },
    setSidebar() {
      this.navbarTitle = this.currentUser.company.company_name;
      let companymeta = JSON.parse(this.currentUser.company.company_meta);


      this.items = [{ icon: "mdi-home", text: "Learning Center", link: "/learningcenter" }]

      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)){
        this.items.push(
        { icon: "mdi-inbox", text: "Inbox", link: "/inbox" },
        { icon: "mdi-account-box", text: "Users", link: "/users" }
        )
        if (companymeta.has_equip_db == "true") {
          this.items.push({
            icon: "mdi-factory",
            text: "Equipment",
            link: "/equipment"
          });
        }
        
      }

      if(this.currentUser.roles.includes(1)){
        this.items.push({ icon: "mdi-group", text: "Groups", link: "/groups" })
        this.items.push({ icon: "mdi-settings", text: "Settings", link: "/Settings" })

      }
      
      if(this.currentUser.roles.includes(2) == false){
        this.items.push(
          { icon: "mdi-file", text: "Courses", link: "/courses" },
          { icon: "mdi-book", text: "Modules", link: "/modules" },
          { icon: "mdi-file-document", text: "Learning material", link: "/learningmaterial" }
        );
        }

    },
    async selLanguage(language) {
      await this.$store.commit(SET_CUR_LANGUAGE, language);
    },
    async contactQuery() {
      if (this.$refs.contactForm.validate()) {
        this.$store
          .dispatch(CONTACT_QUERY, {
            subject: this.subject,
            body: this.body,
            send_copy: this.sendCopy
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.message = "Query successfully sent";
              this.$store.commit(SET_LOADING, false);
            }
            else{
              this.$store.commit(SET_LOADING, false);
            }
          });
      }
    },
    setDropdown() {
      let pages = this.pagesdata.filter(o => o.page_slug !== 'legalnotice').map(function(obj) {
          return {
            icon: obj.icon_code,
            text: obj.page_title,
            action: obj.page_slug
          };
      });

      if (this.currentUser.company.account_type == "on-demand") {
        this.dropdown = [
          { icon: "mdi-account-box", text: "Profile", action: "profile" },
          { icon: "mdi-calculator", text: "Invoices", action: "invoices" }
        ];
      } else {
        this.dropdown = [
          { icon: "mdi-account-box", text: "Profile", action: "profile" }
        ];
      }

      pages.forEach(item => this.dropdown.push(item));

      this.dropdown.push({
        icon: "mdi-power",
        text: "Logout",
        action: "logout"
      });
    },
    fetchPages() {
      this.$store
        .dispatch(FETCH_PAGES, "?lang_ids=" + this.curLanguage.lang_id).then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.setDropdown()    
            this.$store.commit(SET_LOADING, false)
          }
        });
    },
    async changedLanguage(value) {
      Vue.i18n.set(value);
      let selectedLanguage = this.languages.find(x => value === x.lang_code);
      await this.$store.commit(SET_CUR_LANGUAGE, selectedLanguage);
      await store.dispatch(PAGES_RESET_STATE);
      await this.$store
        .dispatch(FETCH_PAGES, "?lang_ids=" + this.curLanguage.lang_id)
        .then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.setDropdown();
            this.$store.commit(SET_LOADING, false)
          }
        });
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
      if (this.isMobile) {
        this.collapseStatus = true;
        store.commit(SET_NAVBAR_WIDTH, 0);
      } else {
        this.collapseStatus = false;
        store.commit(SET_NAVBAR_WIDTH, 80);
      }
    },
    action(status) {
      switch (status) {
        case "profile":
          this.$router.push("/profile");
          break;
        case "logout":
          Promise.all([
            this.$store.commit(SET_LOGGED_IN, false),
            this.$store.dispatch(STRIPE_RESET_STATE),
            this.$store.dispatch(PAGES_RESET_STATE),
            this.$store.dispatch(RESET_STATE),
            this.$store.dispatch(GLOBALS_RESET_STATE),
           this.$store.dispatch(LOGOUT),            
          ]).finally(() => { 
            this.$router.push("/login");
          });
          break;
        default:
          this.$router.push("/pages/" + status);
      }
    },
    status: function() {
      this.$store.dispatch(FETCH_NAVIGATION_BAR_STATUS);
    }
  },
  computed: {
    ...mapGetters([
      "mini",
      "languages",
      "currentUser",
      "widthValue",
      "pagesdata",
      'curLanguage'
    ]),
    languageLabel(){
      return this.$t('Language')
    },
    languagesdata(){
      return this.languages.map(data =>{
        return{
         'lang_code': data.lang_code,
         'lang_id':  data.lang_id,
         'lang_name': this.$t(data.lang_name),
        }
     
      })
    },
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    }
  }
};
</script>